import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../../../utils/constants';

const downloadDocument = async (documentId, accountNumbers, displayName) => {
  try {
    const res = await axios.get(
      `${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.documents.downloadFile}`,
      {
        params: { fileId: documentId },
        headers: { accountNumbers: Array.isArray(accountNumbers) ? accountNumbers.join(',') : accountNumbers },
        responseType: 'blob',
      },
    );

    if (res.status === 200) {
      const contentDisposition = res.headers['content-disposition'];

      let fileName = null;

      if (contentDisposition) {
        const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
        const normalMatch = contentDisposition.match(/filename="?([^";]+)"?/);

        let originalName = null;
        if (utfMatch) {
          [, originalName] = utfMatch;
          originalName = decodeURIComponent(originalName);
        } else if (normalMatch) {
          [, originalName] = normalMatch;
        }

        if (originalName && !/^download$/i.test(originalName.replace(/\.[^/.]+$/, ''))) {
          const baseName = originalName.replace(/\.[^/.]+$/, '');
          fileName = `${baseName}.pdf`;
        }
      }

      if (!fileName && displayName) {
        const hasExtension = /\.[a-zA-Z0-9]{2,4}$/.test(displayName);
        fileName = hasExtension ? displayName : `${displayName}.pdf`;
      }

      if (!fileName) {
        fileName = 'document.pdf';
      }

      // Force PDF type
      const blob = new Blob([res.data], { type: 'application/pdf' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Download failed:', error);
  }
};

export default downloadDocument;
